export default "__VITE_ASSET__BpRCRiWT__"